import { CommonResponseModel, userDetailValueModel } from "../Models/tableDetailsModel";

export interface RoleAccess {
    insights: boolean;
    escalated: boolean;
    settings: boolean;
    lnid: boolean;
    threeps: boolean;
    quotes: boolean;
}

export const useRoles = (
    userDetail: CommonResponseModel<userDetailValueModel>
): RoleAccess => {
    if(!userDetail.flagStatus) {
        return {
            insights: false,
            escalated: false,
            settings: false,
            lnid: false,
            threeps: false,
            quotes: false
        }
    }

    const hasRole = (name: string) => userDetail.value.userRoles.some((r) => r.roleName === name);

    const lnid = hasRole("LNID");

    const threeps = hasRole("3PS");

    return { 
        insights: hasRole("Application"),
        escalated: hasRole("Escalated"),
        settings: lnid || threeps,
        lnid: lnid,
        threeps: threeps,
        quotes: hasRole("Quotes")
    }
}
